const contactMain = document.querySelector(".contact-main");
const contactBlocks = document.querySelector(".contact-blocks");
const selects = document.querySelectorAll(".custom-select");
const tabSelects = contactMain.querySelectorAll(".tab-selects");
const forms = contactMain.querySelectorAll(".form");
const formsBlock = contactMain.querySelector(".forms");




selects.forEach((select, i) => {
    select.classList.add("hidden");
    const closest = select.closest(".wpcf7-form-control-wrap");
    const options = select.querySelectorAll("option");
    const div = document.createElement("div");
    div.classList.add("cs");

    const p = document.createElement("p");
    p.classList.add("cs_current");

    const ul = document.createElement("ul");
    ul.classList.add("cs_list");

    for (let j = 0; j < options.length; j++) {
        const option = options[j];
        const li = document.createElement("li");
        li.classList.add("another-f");
        li.innerHTML = option.textContent;

        if (j === 0) {
            p.innerHTML = option.textContent;
        }

        const text = li.textContent
        li.addEventListener("click", function () {
            let isFormChanged = false
            forms.forEach(form => {
                const title = form.getAttribute("data-title")
                if (text === title) {
                    forms.forEach(form => form.classList.remove("active"));
                    isFormChanged = true
                    form.classList.add("active")

                    ul.classList.remove("active");
                    p.classList.remove("active");
                }
            })

            if (!isFormChanged) {
                isFormChanged = true
                select.selectedIndex = j;
                p.textContent = text;
                ul.classList.remove("active");
                p.classList.remove("active");
            }
        });

        ul.appendChild(li);
    }

    if (closest) {
        div.append(p);
        div.append(ul);
        closest.append(div);
    }

    p.addEventListener("click", () => {
        document.querySelectorAll(".cs_list.active").forEach(activeUl => {
            if (activeUl !== ul) {
                activeUl.classList.remove("active");
                activeUl.previousElementSibling.classList.remove("active");
            }
        });
        ul.classList.toggle("active");
        p.classList.toggle("active");
    })
})

// TABS

const buttons = contactBlocks.querySelectorAll(".button");
if (buttons.length > 0 && forms.length > 0) {
    buttons[0].classList.add("active");
    forms[0].classList.add("active");
}
buttons.forEach((button, index) => {
    button.addEventListener("click", () => {
        buttons.forEach(btn => btn.classList.remove("active"));
        forms.forEach(form => form.classList.remove("active"));
        button.classList.add("active");
        forms[index].classList.add("active");
        const offsetTop = formsBlock.getBoundingClientRect().top + window.scrollY - 128;

        window.scrollTo({
            top: offsetTop,
            behavior: "smooth"
        });
    });
});



